import { InjectionToken } from '@angular/core';

export interface FormSourceProvider {
  getCompareSource(): any;
  getSource(): any;
}

export const FORM_SOURCE_TOKEN = new InjectionToken<FormSourceProvider>('FORM_SOURCE_TOKEN');
